"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_EDD_VARIABLE = exports.DELETE_EDD_VARIABLE = exports.CREATE_EDD_VARIABLE = void 0;
const client_1 = require("@apollo/client");
exports.CREATE_EDD_VARIABLE = (0, client_1.gql) `
  mutation CreateEDDVariable(
    $input: CreateEstimatedDeliveryDateVariableInput!
  ) {
    createEstimatedDeliveryDateVariable(input: $input) {
      estimatedDeliveryDateVariable {
        id
        description
        name
        reserved
        type
        ... on DateRangeVariable {
          maxDays
          minDays
        }
        ... on DateVariable {
          minDays
        }
      }
    }
  }
`;
exports.DELETE_EDD_VARIABLE = (0, client_1.gql) `
  mutation DeleteEDDVariable(
    $input: DeleteEstimatedDeliveryDateVariableInput!
  ) {
    deleteEstimatedDeliveryDateVariable(input: $input) {
      ok
    }
  }
`;
exports.UPDATE_EDD_VARIABLE = (0, client_1.gql) `
  mutation UpdateEDDVariable(
    $input: UpdateEstimatedDeliveryDateVariableInput!
  ) {
    updateEstimatedDeliveryDateVariable(input: $input) {
      estimatedDeliveryDateVariable {
        id
        description
        name
        reserved
        type
        ... on DateRangeVariable {
          maxDays
          minDays
        }
        ... on DateVariable {
          minDays
        }
      }
    }
  }
`;
